import { Component, DestroyRef, Inject, OnInit, PLATFORM_ID, TransferState, computed, inject, makeStateKey } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, noop, of, tap } from 'rxjs';

import { MainCategory1 } from 'projects/shared/models/category';
import { CategoryService } from 'projects/shared/services/category.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { NotificationSocketService } from 'projects/shop/src/app/+shared/services/notificationSocket.service';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';
import { Store } from '@ngrx/store';
import { SelectRegionalLanguage } from '../navbar-header/partials/nav-regional/store/regional-setting.selectors';

const MAIN_CATEGORIES_KEY = makeStateKey<any>('main-categories-nav-links');

@Component({
  selector: 'app-navbar-links',
  templateUrl: './navbar-links.component.html',
  styleUrls: ['./navbar-links.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class NavbarLinksComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  private readonly supportedLangs = ['en', 'ar'];
  private socketInitialized = false;

  mainCategoryList?: MainCategory1[];
  language$ = this._store.selectSignal(SelectRegionalLanguage);
  langCode$ = computed<LangCode>(() => this.language$() as LangCode);

  constructor(
    private categoryService: CategoryService,
    private storeChangesServ: StoreChangesService,
    private router: Router,
    private notificationSocketService: NotificationSocketService,
    private transferState: TransferState,
    private _languageService: LanguageService,
    private _store: Store,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {


    this.getAllMainCategories();
  }





  trackBySlug(_index: number, item: any): string {
    return item.slug;
  }

  navigateToCategory(item: any): void {
    this.mainCategoriesLocal(item.name);
  }

  mainCategoriesLocal(mainCategoryName: {}): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('mainCategoryNameFromNavbar', JSON.stringify(mainCategoryName));
    }
  }

  getAllMainCategories(): void {
    const cached = this.transferState.get<any>(MAIN_CATEGORIES_KEY, null);
    const source$ = cached
      ? of(cached)
      : this.categoryService.getUserMainCategories('?sort=order').pipe(
        tap(response => {
          if (!isPlatformBrowser(this.platformId)) {
            this.transferState.set(MAIN_CATEGORIES_KEY, response);
          }
        })
      );

    source$.pipe(
      tap((response: any) => {
        this.categoryService.mainCategories.next(response);
        this.mainCategoryList = response.data;
        this.initNotificationSocket();
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(noop);
  }

  initNotificationSocket(): void {
    if (this.socketInitialized || !isPlatformBrowser(this.platformId)) return;
    this.socketInitialized = true;

    this.storeChangesServ.getUser().pipe(
      tap(user => {
        if (user) this.notificationSocketService.initSocket(user._id);
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(noop);
  }
}


type LangCode = 'ar' | 'en';